let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5t3NJ")).then(() => parcelRequire('549Do'));